export default __webpack_public_path__ + "static/media/VsCode.54c2de39.png";